import ButtonDemo from './demos/ButtonDemo';
import InputDemo from './demos/InputDemo';
import TextareaDemo from './demos/TextareaDemo';
import CardDemo from './demos/CardDemo';
import BadgeDemo from './demos/BadgeDemo';
import DialogDemo from './demos/DialogDemo';
import AlertDemo from './demos/AlertDemo';
import MessageDemo from './demos/MessageDemo';
import LoadingDemo from './demos/LoadingDemo';
import './ComponentShowcase.css';

export default function ComponentShowcase() {
  return (
    <div className="component-showcase">
      <section id="button" className="component-section">
        <ButtonDemo />
      </section>

      <section id="input" className="component-section">
        <InputDemo />
      </section>

      <section id="textarea" className="component-section">
        <TextareaDemo />
      </section>

      <section id="card" className="component-section">
        <CardDemo />
      </section>

      <section id="badge" className="component-section">
        <BadgeDemo />
      </section>

      <section id="dialog" className="component-section">
        <DialogDemo />
      </section>

      <section id="alert" className="component-section">
        <AlertDemo />
      </section>

      <section id="message" className="component-section">
        <MessageDemo />
      </section>

      <section id="loading" className="component-section">
        <LoadingDemo />
      </section>
    </div>
  );
}
